export const store = {
	code: 'RCT',
	description: 'Recojo en tienda',
	value: 2,
};
export const delivery = {
	code: 'EAD',
	description: 'Envío a Domicílio',
	value: 1,
};



// WEBPACK FOOTER //
// ./src/shared/enums/waysDeliveries.js